import React, {useEffect, useState} from 'react';
import Container from "@mui/material/Container";
import EndOfOrder from "./EndOfOrder";
import {useSearchParams} from "react-router";
import {getDatabase, ref, onValue} from "firebase/database";
import {CircularProgress} from "@mui/material";
import app, {logGAEvent} from "../../firebaseConfig/firebaseConfig";
import Box from "@mui/material/Box";

const db = getDatabase(app);

function EndOfOrderPage(props) {
    const [params] = useSearchParams();
    const [paymentCode, setPaymentCode] = useState(null);
    const [cardPaymentURL, setCardPaymentURL] = useState(null);
    const orderId = params.get('orderId');

    useEffect(() => {
        const pendingOrdersRef = ref(db, `/pendingOrders/${orderId}/status`);
        onValue(pendingOrdersRef, snapshot => {
            const status = snapshot.val();
            if (status === 'error') {
                onValue(ref(db, `/pendingOrders/${orderId}/cardPayment/payment/paymentURL`), snapshot => {
                    const cardPaymentURLVal = snapshot.val();
                    setCardPaymentURL(cardPaymentURLVal);
                    setPaymentCode(status || 'not-found');
                });
            } else {
                window.fbq('track', 'Purchase', {currency: "RON"});
                logGAEvent('purchase', {orderId});
                setPaymentCode(status || 'not-found');
            }
        });
    }, [orderId]);

    return (
        <Container maxWidth="md" sx={{pt: 12}}>
            {paymentCode && paymentCode !== 'in-progress' ?
                <EndOfOrder orderId={orderId} error={paymentCode === 'error'} notFound={paymentCode === 'not-found'} cardPaymentURL={cardPaymentURL}/> :
                <Box sx={{textAlign: 'center'}}><CircularProgress/></Box>}
        </Container>
    );
}

export default EndOfOrderPage;
